module.exports = __webpack_public_path__ + "static/media/bentley.173e5ad3.png";